__turbopack_context__.v({
  "tab": "Tabs-module__3M7F6q__tab",
  "tabSelected": "Tabs-module__3M7F6q__tabSelected",
});
